import { render, staticRenderFns } from "./clearGoods.vue?vue&type=template&id=4dee32c8"
import script from "./clearGoods.vue?vue&type=script&lang=js"
export * from "./clearGoods.vue?vue&type=script&lang=js"
import style0 from "./clearGoods.vue?vue&type=style&index=0&id=4dee32c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports